import { ICompany } from "@/api/AppApi/services/company/interfaces/ICompany";
import { i18n } from "../../../i18n-config";

export const ProductIndexPriority = 0;

export const mobileProductGrid = {
  outerPadding: 15,
  gap: 8,
};

export const getPCAppHorPadding = (isStandardWidth: boolean): number => {
  const PCAppHorPadding = 24;
  const PCAppHorPaddingFullWidth = 48;
  return isStandardWidth ? PCAppHorPadding : PCAppHorPaddingFullWidth;
};

export const getPCMaxAppWidth = (isStandardWidth: boolean): number => {
  const PCMaxAppWidthWithoutPadding = 1204;
  const PCAppFullWidth = 4000;
  return (
    (isStandardWidth ? PCMaxAppWidthWithoutPadding : PCAppFullWidth) +
    2 * getPCAppHorPadding(isStandardWidth)
  );
};
export const isHomePage = (url: string) => {
  const urlTerms = url.split("/");
  if (urlTerms.length === 2 && ["", ...i18n.locales].includes(urlTerms[1]))
    return true;
  return false;
};

export const mobileHeaderBreakPoint = 992;
export const mobileBodyBreakPoint = 768;
export const mobileProductBox = 450;
export const isDev = process.env.NODE_ENV !== "production";

export const isServer = () => typeof window === "undefined";

// export const isSSR = (_: any) => false;
//!req.url.startsWith("/_next");
const baseURL = process.env.NEXT_PUBLIC_V3_BASE_URL as string;

const topwinnerUat = 3248;

export const IsTopWinner = (company: ICompany) =>
  company?.id === (baseURL.includes("uatososs") ? topwinnerUat : 3445);

export const isKWCompliance = (company: ICompany) => company?.id === 898;

export const isKimbo = (company: ICompany) => company?.id === 4536;

export const IsGhayaGroup = (company: ICompany) => company?.id === 3260;

export const absURl = (r_url: string) => {
  const baseURL = process.env.NEXT_PUBLIC_V3_BASE_URL;
  const companyId = process.env.NEXT_PUBLIC_V3_COMPANY_ID;
  let src = `${baseURL}/company${r_url}`;
  src += `?company-id=${companyId}`;
  return src;
};
